import { QuestionBase } from "./question-base.model";

export class DropdownQuestion extends QuestionBase<string> {
   controlType = 'dropdown';
   id: string;
   getterKey = null;
   getterValue = null;
   flag: boolean;
   options: { key: string, value: string }[] = [];
   disabled: boolean;
   value: any;
   config = {};
   dropdownParent: any;
   datasource: any;
   dropdownMyParent: any;
   conditions: any;
   visible: boolean;
   populate_field: boolean;
   req_keys: any;
   resource_add: boolean;
   defaultValue: any;
   formAutofill: any;
   format: any;
   default: any;
   view_key: any;
   index: number;
   class_conditions: any;
   stopSorting: any;
   sortType: any;
   removeSelect: any;
   sortBy: any;
   showMore: any;
   getAssignedFacilityList: any;

   constructor(options: {} = {}) {
      super(options);
      this.options = options['options'] || [];
      this.id = options['id'];
      this.getterKey = options['getterKey'] || null;
      this.getterValue = options['getterValue'] || null;
      this.disabled = (options['disabled'] == undefined) ? false : options['disabled'];
      this.flag = options['flag'] || false;
      this.config = options['config'] || null;
      this.value = options['default'] || '';
      this.datasource = options['datasource'] || null;
      this.conditions = options['conditions'];
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.populate_field = (options['populate_field'] == undefined) ? false : options['populate_field'];
      this.req_keys = options['req_keys'] || false;
      this.resource_add = (options['resource_add'] == undefined) ? false : options['resource_add'];
      this.defaultValue = options['defaultValue'];
      this.formAutofill = options['formAutofill'];
      this.format = options['format'];
      this.default = options['default'];
      this.view_key = options['view_key'] || false;
      this.index = options['index'];
      this.class_conditions = options['class_conditions'] == undefined ? false : options['class_conditions'];
      this.sortType = options['sortType'] || false;
      this.stopSorting = options['stopSorting'] == undefined ? false : options['stopSorting'];
      this.removeSelect = options['removeSelect']==undefined ? false:options['removeSelect'];
      this.sortBy = options['sortBy']==undefined?false:options['sortBy'];
      this.showMore = options['showMore']==undefined ? false:options['showMore'];
      this.getAssignedFacilityList = options['getAssignedFacilityList'] == undefined ? false : options['getAssignedFacilityList'];

   }
}
